export default {
  en: {
    global: {
      activity: 'Activity',
      group: 'Group',
      agency: 'Agency',
      read_more: 'Read more',
      click_here_to_create_one: 'Click {here} to create one.',
      name: 'Name',
      email: 'Email address',
      type: 'Type',
      role: 'Role',
      add_a_role: 'Add a role...',
      pick_a_role: 'Pick a role...',
      no_role_results:
        'There are no results, please try different wording or contact us if you miss a role.',
      role_search_explanation: 'Type to search, then select one of the pre-defined roles.',
      overview: 'Overview',
      role_explanation:
        'If you can\'t find the role, please use "Other" for now and send us a request to add it.',
      as_stand_in: 'As stand-in',
      add: 'Add',
      edit: 'Edit',
      save: 'Save',
      send: 'Send',
      sent: 'Sent',
      done: 'Done',
      all: 'All',
      select: 'Select',
      none: 'None',
      apply: 'Apply',
      select_your_answer: 'Select your answer...',
      yes: 'Yes',
      no: 'No',
      confirmation_question: 'Are you sure?',
      delete: 'Delete',
      description: 'Description',
      cancel: 'Cancel',
      details: 'Details',
      phone: 'Phone',
      terms: 'Terms',
      privacy_policy: 'Privacy policy',
      not_applicable: 'n/a',
      manual: 'Manual',
      info: 'Info',
      updated_at: 'Updated at',
      created_at: 'Created at',
      need_help:
        'Do you need assistance with creating or activating your account? Please reach out to us.',
      today: 'Today',
      logout: 'Logout',
      missing_group_name: 'your group',
      download: 'Download',
      quick_create: 'Create',
      new: 'New',
      number_of_days: 'a day|{count} days',
      trial: 'trial',
      plan_subscription: '{plan} subscription',
      copy_current_url: 'Copy current URL',
      date_format: 'YYYY-MM-DD',
      time_format: '--:--',
      optional: 'Optional',
      skip: 'Skip',
      copyright: 'All rights reserved',
      website: 'Go to website',
      updated: 'Updated',
      created: 'Created',
      here: 'here',
      back_to_overview: 'Back to overview',
      new_activity: 'New activity',
      search: 'Search',
      search_placeholder: 'Type to search...',
      search_no_results: 'There are no results.',
      search_category: {
        activity: 'Activity',
        contact: 'Contact',
        group: 'Group',
      },
      pro: {
        title: 'GigPlanner Pro',
        description:
          'This feature is currently free for all users, but will be part of the new GigPlanner Pro plan later this year.',
      },
    },
    date_picker: {
      i18n: {
        previousMonth: 'Previous Month',
        nextMonth: 'Next Month',
        months: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      },
    },
    reports: {
      title: 'Generate report',
      period: 'Period',
      until: 'to',
      groups: 'Groups',
      activity_types: 'Activity types',
      field_title: 'Fields',
      field_locked: 'Required',
      fields: {
        type: 'Activity type',
        when: 'When',
        start: 'Start',
        end: 'End',
        group: 'Group',
        title: 'Title',
        location: 'Location',
        location_details: 'Location details (Only when using Google Maps)',
        location_details_header: 'Location details',
        location_detail_fields: {
          name: 'Location name',
          postal_code: 'Location postal code',
          locality: 'Location city',
          administrative_area_level_1: 'Location area',
          country: 'Location country',
        },
        description: 'Description',
        participants: 'Participants',
        participants_per_role: 'Participants per role',
        url: 'Link to GigPlanner',
      },
      submit: 'Download as CSV',
    },
    attachments: {
      title: 'Attachments',
      add: 'Add attachment',
      loading: 'Loading attachments',
      confirm_deletion: 'Are you sure you want to delete this attachment? This can not be undone.',
      deletion_failed:
        'We could not delete this attachment. Please try again later or contact us for support.',
      uploading_failed:
        'We could not upload the attachment at this time. Please try again later or contact us for support.',
      deleting: 'Deleting attachment',
      max_filesize_exceeded: 'The maximum file size is 50MB.',
    },
    activity_attachments: {
      title: 'Attachments',
      add: 'Add Attachment',
      loading: 'Loading attachments',
      confirm_deletion: 'Are you sure you want to delete this attachment?',
      deletion_failed:
        'We could not delete this attachment. Please try again later or contact us for support.',
      uploading_failed:
        'We could not upload the attachment at this time. Please try again later or contact us for support.',
      state: {
        preparing: 'Preparing for upload',
        uploading: 'Uploading',
        processing: 'Processing file',
      },
      deleting: 'Deleting attachment',
    },
    task: {
      task_title: 'Tasks',
      title_placeholder: 'Enter task and press return...',
      description_placeholder: 'Enter task description...',
      assign_user: 'Assign user',
      remove_assigned_user: 'Remove assigned user',
      show_activity: 'Show activity',
      filter: 'Filter',
      show_completed: 'Show completed',
      only_assigned_to_me: 'Only assigned to me',
      tooltips: {
        completed_by_user: 'Completed by',
        assign_to: 'Assign to member',
        assigned_to: 'Assigned to',
        set_due_date: 'Set due date',
        due_by: 'Due by',
        completed_at: 'Completed at',
        description: 'Add description',
      },
      loading: 'Loading tasks',
    },
    documents: {
      by: 'Sender',
      concept_reference: 'Concept {number}',
      confirm_cancel:
        "Are you sure you want to cancel this document? The recipient won't be able to see the document.",
      confirm_delete: 'Are you sure you want to delete this document? This can not be undone.',
      contact: 'Contact',
      content_placeholder: 'This document does not have any content yet.',
      create: 'New document',
      create_template:
        'Do you need to create this type of document again? Consider clicking {here} to create a template.',
      date: 'Date',
      default_type: 'Document',
      duplicate: 'Duplicate document',
      empty: 'You have not created an document yet.',
      emptyState: {
        action: 'Create document',
        description: 'Get started by creating your first document.',
        title: 'No documents',
      },
      history: {
        status: {
          approved: 'Approved with digital signature',
          draft: 'Document created',
          sent: 'Sent to {recipient}',
        },
      },
      history_description: 'At {time} by {by}',
      is_signable: 'Should be signed by recipient',
      messages: {
        cancelled: 'Document was cancelled.',
        deleted: 'Document was deleted.',
        no_owner_available: 'You need to create a group or agency before you can create documents.',
        updated: 'Document was updated.',
      },
      no_activity: 'No activity',
      no_contact: 'No contact',
      no_template: 'No template',
      reference: 'Reference',
      select_an_activity:
        'Do you want to create this document based on an activity? Click {here} to look up the activity. Create the document on the activity page.',
      select_owner: 'Select sender...',
      send: 'Send',
      status: 'Status',
      submit_create: 'Create document',
      template: 'Template',
      title: 'Documents',
      type: 'Type',
      view_document: 'View document',
    },
    placeholders: {
      title: 'Placeholders',
      explanation:
        'Add any placeholders to your template. When creating an document they will be filled with the relevant data.',
      types: {
        document: 'Document',
        group: 'Group',
        contact: 'Contact',
        activity: 'Activity',
        'activity-custom': 'Custom fields',
      },
      items: {
        'creation-date': 'Creation date',
        'expiry-date': 'Expiry date',
        creator: 'Creator',
        'full-contact-details': 'Full contact details',
        company: 'Company',
        group: 'Group',
        name: 'Name',
        owner: 'Owner',
        'owner-email': 'Email address',
        'owner-phone': 'Phone number',
        address: 'Address',
        postcode: 'Postcode',
        city: 'City',
        country: 'Country',
        phone: 'Phone',
        email: 'Email address',
        website: 'Website',
        type: 'Type',
        'start-date': 'Start date',
        'start-time': 'Start time',
        'end-date': 'End date',
        'end-time': 'End time',
        soundcheck: 'Soundcheck time',
        present: 'Present time',
        title: 'Title',
        description: 'Description',
        location: 'Location',
      },
    },
    activity: {
      create_title: 'New activity',
      pending_invitation: 'Invitation pending',
      form: {
        description: 'What',
        description_placeholder: 'Description of the activity',
        location: 'Where',
        location_placeholder: 'Location of the activity',
        submit_create_of_type: 'Create {type}',
        from: 'from',
        to: 'to',
        duration: 'When',
        part_of_day: 'Day and time',
        whole_day: 'Day',
        multiple_days: 'Period',
        submit_update_of_type: 'Save {type}',
        until: 'until',
        recurring: 'Recurring',
        submit_update_this: 'Save this activity',
        submit_update_all: 'Save all future activities',
        participants: 'Participants',
        present_time: 'Present at',
        soundcheck_time: 'Soundcheck at',
        requires_approval: 'Ask approval of group members',
        notify_participants: 'Notify participants about the update',
      },
      attributes: {
        duration_type: 'duration type',
        start_date: 'start date',
        end_date: 'end date',
        start_time: 'start time',
        end_time: 'end time',
        present_time: 'present',
        soundcheck_time: 'soundcheck',
        recurring: 'recurring',
        participants: 'participants',
        requires_approval: 'requires approval',
      },
      messages: {
        created_of_type: 'The {type} has been created.',
        updated_of_type: 'The {type} has been updated.',
        deleted_of_type: 'The {type} has been deleted.',
      },
      by: 'By',
      description: 'Description',
      location: 'Location',
      confirm_delete: 'Are you sure you want to delete this activity?',
      back_to_calendar: 'Back to calendar',
      update_of_type: 'Edit {type}',
      group: 'Group',
      select_group: 'Select a group',
      recurring: {
        weekly: 'Weekly',
        monthly: 'Monthly',
        yearly: 'Yearly',
        not_recurring: 'Not recurring',
        biweekly: 'Biweekly',
      },
      date_warning: {
        end_on_next: 'Activity ends on the following day.',
        present_on_previous: 'Present is on the previous day.',
        soundcheck_on_previous: 'Soundcheck is on the previous day.',
        present_and_soundcheck_on_previous: 'Present and soundcheck are on the previous day.',
      },
      confirm_delete_all_future:
        "Are you sure you want to delete this activity and all it's future occurrences?",
      submit_delete_this: 'Delete this activity',
      submit_delete_all: 'Delete all recurrences',
      participants: 'Participants',
      choose_group_for_type: 'Choose group for {type}',
      present: 'Present',
      soundcheck: 'Soundcheck',
      approve: 'Approve',
      reject: 'Reject',
      promote_to_type: 'Promote to {type}',
      maybe: 'Maybe',
      confirm_promote_from_old_type_to_type:
        'Are you sure you want to change this {oldType} to a {type}? This cannot be undone.',
      send_participation_state_reminder: 'Send reminder',
      date: 'Date',
      from: 'From',
      to: 'To',
      until: 'Until',
      time: 'Time',
      place: {
        view_on_google_maps: 'View on Google Maps',
      },
      choose_location_with_google_maps: 'Location is now autocompleted by Google Maps.',
      limit_reached_for_type: 'Reached limit for {type}',
      limit_reached_body:
        'You have reached the limit of {type} you can create. Before you can create more {type}, you will either have to remove some {type} or upgrade your account.',
      validation: {
        limit_reached_without_type: 'Reached limit for this activity type',
        limit_reached_for_type: 'This group has reached its limit for {type}.',
      },
      busy_state: 'Busy ({type})',
      no_group: 'No group (Personal)',
      confirm_reset_participation_state:
        'Are you sure you want to reset the state of this participant? The member will be notify to answer again.',
      reset: 'Reset',
      promote_to_many: 'Promote to...',
      created_by_at: 'Created by {by} on {at}.',
      updated_at: 'Last updated on {at}.',
      contacts: 'Contacts',
      tasks: 'Tasks',
      type: 'Activity type',
      create: 'Create activity',
      title: 'Title',
      participation_without_user: '(unknown member)',
      documents: 'Documents',
      create_document: 'Create document',
    },
    calendar: {
      no_activities_in_month: 'There are no activities this month.',
      all_day: 'All day',
      apply_filter: 'Apply filter',
      today: 'Today',
      filter_toggle: 'Filter',
      filter_type: 'Types',
      filter_group: 'Groups',
      submit_filter: 'Apply filter',
      week: 'Week',
      month: 'Month',
      list: 'List',
      filter: {
        types: 'Types',
        groups: 'Groups',
        unfiltered: 'All',
        filtered: 'Filtered ({count})',
      },
      presets: {
        this_week: 'This week',
        last_week: 'Last week',
        this_month: 'This month',
        last_month: 'Last month',
        this_year: 'This year',
        last_year: 'Last year',
        today: 'Today',
      },
      when: 'When',
      activity: 'Activity',
      location: 'Location',
      participants: 'Participants',
      day: 'Day',
      no_activities_on_this_day: 'There are no activities for this day.',
      number_of_activities: '{0} No activities|{1} 1 activity|[2,*] {count} activities',
      'no-activities': 'There are no activities in this period.',
      'show-participants-overview': 'Show participant overview',
      'show-user-activities': 'Show user activities',
      max_period: 'List can show a period up to a year.',
      'show-groups-without-activities': 'Show groups without activities',
      'day-groups-full-width': 'Use full width for each group',
    },
    activity_contacts: {
      title: 'Contacts',
      add_placeholder: 'Add contact to this activity...',
      add_button: 'Add',
      view_contact: 'View',
      other_role: 'Other',
      create_new: 'Create new contact',
      notes: {
        create_placeholder: 'Add new note to contact...',
        confirm_deletion: 'Are you sure you want to delete this note? This cannot be undone.',
        submit: 'Add',
        title: 'Notes',
      },
    },
    contacts: {
      address: 'Address',
      agency: 'Agency',
      back_to_overview: 'Back to contacts',
      city: 'City',
      company: 'Company',
      confirm_delete:
        "Are you sure you want to delete this contact? It will also be removed from all activities it's linked to.",
      country: 'Country',
      create: 'Create new contact',
      edit: 'Update contact details',
      email: 'Email Address',
      empty: "You haven't added any contacts yet.",
      emptyState: {
        action: 'Create contact',
        description: 'Get started by creating your first contact.',
        title: 'No contacts',
      },
      filter: {
        filtered: 'Filtered ({count})',
        unfiltered: 'All',
      },
      group: 'Group',
      messages: {
        created: 'The contact was created successfully.',
        deleted: 'Succesfully deleted the contact.',
        updated: 'Contact has been updated.',
      },
      name: 'Name',
      overview_title: 'Contacts',
      owner: 'Owner of contact',
      personal: 'Personal',
      phone: 'Phone',
      postcode: 'Postcode',
      role: 'Role',
      roles: 'Roles',
      select_a_role: 'Select a role...',
      submit_create: 'Create contact',
      submit_update: 'Save contact',
      tags: {
        create_new: 'Create new tag',
        label: 'Tags',
        placeholder: 'Add a tag...',
      },
      view_all: 'View all contacts',
      website: 'Website',
    },
    invitation: {
      invite_to_invitee: {
        members: 'Invite member to join {invitee}',
        groups: 'Invite group to join {invitee}',
        agents: 'Invite agent to join {invitee}',
      },
      select_role: 'Select a role',
      as_stand_in: 'As stand-in',
      message: {
        deleted: 'Successfully deleted invitation.',
        sent_amount: 'Invitation has been sent.|Invitations have been sent.',
      },
      submit_send: 'Send invitation',
      add_more: 'Invite more people',
      attributes: {
        name: 'name',
        email: 'email address',
        role: 'role',
        as_stand_in: 'as stand-in',
      },
      confirm_deletion: 'Are you sure you want to remove this invitation? The data will be lost.',
    },
    document_templates: {
      agency: 'Agency',
      confirm_delete: 'Are you sure you want to delete this template? This can not be undone.',
      content: 'Content',
      create: 'New template',
      description: 'Description',
      empty: "You don't have any templates yet.",
      emptyState: {
        action: 'Create template',
        description: 'Get started by making your first template.',
        title: 'No templates',
      },
      group: 'Group',
      is_signable: 'Should be signed by recipient',
      messages: {
        created: 'Template is created and can be used for new templates.',
        deleted: 'Template was deleted.',
        no_owners: 'There are no groups or agencies to create a template for.',
        updated: 'Template was updated.',
      },
      name: 'Name',
      owner: 'For',
      pick_owner: 'Select a group or agency...',
      submit_create: 'Create template',
      submit_update: 'Save template',
      title: 'Templates',
      update: 'Update template',
      validity_days: 'Days valid',
    },
  },
  nl: {
    global: {
      activity: 'Activiteit',
      group: 'Groep',
      agency: 'Agency',
      read_more: 'Lees meer',
      click_here_to_create_one: 'Klik {here} om er een aan te maken.',
      edit: 'Wijzigen',
      save: 'Opslaan',
      send: 'Verstuur',
      done: 'Klaar',
      name: 'Naam',
      all: 'Alles',
      select: 'Selecteer',
      none: 'Geen',
      apply: 'Toepassen',
      email: 'E-mailadres',
      type: 'Type',
      role: 'Rol',
      add_a_role: 'Voeg rol toe...',
      pick_a_role: 'Kies rol toe...',
      no_role_results:
        'Er zijn geen rollen gevonden. Probeer een andere benaming of neem contact met ons op.',
      role_search_explanation:
        'Typ om een rol te vinden, kies daarna een van de voorgedefini\u00eberde rollen.',
      overview: 'Overzicht',
      role_explanation:
        'Indien je geen geschikte rol kan vinden, gebruik dan "Overig" en stuur ons een verzoek voor nieuwe rol.',
      as_stand_in: 'Als invaller',
      add: 'Voeg toe',
      sent: 'Verstuurd',
      select_your_answer: 'Selecteer een optie...',
      yes: 'Ja',
      no: 'Nee',
      confirmation_question: 'Weet je het zeker?',
      delete: 'Verwijderen',
      description: 'Omschrijving',
      cancel: 'Annuleer',
      details: 'Details',
      phone: 'Telefoon',
      terms: 'Gebruiksvoorwaarden',
      privacy_policy: 'Privacyverklaring',
      not_applicable: 'n.v.t.',
      manual: 'Handleiding',
      info: 'Info',
      updated: 'Gewijzigd',
      updated_at: 'Gewijzigd op',
      created: 'Aangemaakt',
      created_at: 'Aangemaakt op',
      need_help:
        'Heb je vragen, opmerkingen of hulp nodig bij registreren of activeren van je account? Neem gerust contact op met ons.',
      today: 'Vandaag',
      logout: 'Uitloggen',
      missing_group_name: 'je groep',
      download: 'Download',
      quick_create: 'Nieuw',
      new: 'Nieuw',
      number_of_days: 'een dag|{count} dagen',
      trial: 'proefabonnement',
      plan_subscription: '{plan} abonnement',
      copy_current_url: 'Kopieer link naar deze pagina',
      date_format: 'JJJJ-MM-DD',
      time_format: '--:--',
      optional: 'Optioneel',
      skip: 'Overlaan',
      copyright: 'Alle rechten voorbehouden',
      website: 'Naar website',
      here: 'hier',
      back_to_overview: 'Terug naar overzicht',
      new_activity: 'Nieuwe activiteit',
      search: 'Zoeken',
      search_placeholder: 'Typ om te zoeken...',
      search_no_results: 'Er zijn geen resultaten.',
      search_category: {
        activity: 'Activiteit',
        contact: 'Contact',
        group: 'Groep',
      },
      pro: {
        title: 'GigPlanner Pro',
        description:
          'Deze functionaliteit is tijdelijk gratis voor alle gebruikers, later dit jaar alleen beschikbaar met het GigPlanner Pro-abonnement.',
      },
    },
    date_picker: {
      i18n: {
        previousMonth: 'Vorige',
        nextMonth: 'Volgende',
        months: [
          'Januari',
          'Februari',
          'Maart',
          'April',
          'Mei',
          'Juni',
          'Juli',
          'Augustus',
          'September',
          'Oktober',
          'November',
          'December',
        ],
        weekdays: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
        weekdaysShort: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
      },
    },
    reports: {
      title: 'Maak overzicht',
      period: 'Periode',
      until: 'tot',
      groups: 'Groepen',
      activity_types: 'Activiteitstypes',
      field_title: 'Velden',
      field_locked: 'Verplicht',
      fields: {
        type: 'Activiteitstype',
        when: 'Wanneer',
        start: 'Start',
        end: 'Einde',
        group: 'Groep',
        title: 'Titel',
        location: 'Locatie',
        location_details: 'Locatie-details (Alleen i.c.m. Google Maps)',
        location_details_header: 'Locatie-details',
        location_detail_fields: {
          name: 'Locatie naam',
          postal_code: 'Locatie postcode',
          locality: 'Locatie plaats',
          administrative_area_level_1: 'Locatie gebied',
          country: 'Locatie land',
        },
        description: 'Omschrijving',
        participants: 'Bezetting',
        participants_per_role: 'Bezetting per rol',
        url: 'Link naar GigPlanner',
      },
      submit: 'Download als CSV',
    },
    attachments: {
      title: 'Bijlages',
      loading: 'Bijlages ophalen',
      add: 'Bijlage toevoegen',
      confirm_deletion:
        'Weet je zeker dat je deze bijlage wil verwijderen? Dit kan niet ongedaan gemaakt worden.',
      deletion_failed:
        'We konden het bestand niet verwijderen. Probeer het later opnieuw of neem contact op voor ondersteuning.',
      uploading_failed:
        'We konden het bestand niet uploaden. Probeer het later opnieuw of neem contact op voor ondersteuning.',
      deleting: 'Bijlage verwijderen',
      max_filesize_exceeded: 'De maximale bestandsgrootte is 50MB.',
    },
    task: {
      task_title: 'Taken',
      title_placeholder: 'Voer titel in en druk op enter...',
      description_placeholder: 'Voer omschrijving in...',
      assign_user: 'Gebruiker toewijzen',
      remove_assigned_user: 'Verwijder toegewezen gebruiker',
      show_activity: 'Toon activiteit',
      filter: 'Filteren',
      show_completed: 'Toon voltooide taken',
      only_assigned_to_me: 'Alleen toegewezen aan mij',
      tooltips: {
        completed_by_user: 'Afgerond door',
        assign_to: 'Toewijzen aan lid',
        assigned_to: 'Toegewezen aan',
        set_due_date: 'Datum toevoegen',
        due_by: 'Vervaldatum',
        completed_at: 'Afgerond op',
        description: 'Omschrijving toevoegen',
      },
      loading: 'Taken ophalen',
    },
    documents: {
      by: 'Van',
      concept_reference: 'Concept {number}',
      confirm_cancel:
        'Weet je zeker dat je deze document wil annuleren? De ontvanger kan het document niet langer inzien.',
      confirm_delete:
        'Weet je zeker dat je deze document wil verwijderen? Dit kan niet ongedaan gemaakt worden.',
      contact: 'Contact',
      content_placeholder: 'Dit document heeft nog geen inhoud.',
      create: 'Nieuw document',
      create_template:
        'Heb je dit soort document vaker nodig? Klik {here} om een sjabloon aan te maken.',
      date: 'Datum',
      default_type: 'Document',
      duplicate: 'Dupliceer document',
      empty: 'Je hebt nog geen documenten.',
      emptyState: {
        action: 'Maak document',
        description: 'Maak een begin door je eerste document aan te maken.',
        title: 'Geen documenten',
      },
      history: {
        status: {
          approved: 'Geaccepteerd met digitale handtekening',
          draft: 'Document aangemaakt',
          sent: 'Verzonden naar {recipient}',
        },
      },
      history_description: 'Om {time} door {by}',
      is_signable: 'Moet ondertekend worden door ontvanger',
      messages: {
        cancelled: 'Het document is geannuleerd.',
        deleted: 'Het document is verwijderd.',
        no_owner_available:
          'Je moet een groep of agency hebben voordat je documenten aan kunt maken.',
        updated: 'Het document is gewijzigd.',
      },
      no_activity: 'Geen activiteit',
      no_contact: 'Geen contact',
      no_template: 'Geen sjabloon',
      reference: 'Referentie',
      select_an_activity:
        'Wil je dit document aanmaken voor een activiteit? Klik {here} om de activiteit op te zoeken. Maak document aan via activiteitpagina.',
      select_owner: 'Selecteer verzender...',
      send: 'Versturen',
      status: 'Status',
      submit_create: 'Document aanmaken',
      template: 'Sjabloon',
      title: 'Documenten',
      type: 'Type',
      view_document: 'Bekijk document',
    },
    placeholders: {
      title: 'Placeholders',
      explanation:
        'Voeg placeholders toe aan je sjabloon, deze worden bij het aanmaken van document gevuld op basis van de gekozen activiteit.',
      types: {
        document: 'Document',
        group: 'Groep',
        contact: 'Contact',
        activity: 'Activiteit',
        'activity-custom': 'Extra velden',
      },
      items: {
        'creation-date': 'Aanmaakdatum',
        'expiry-date': 'Verloopdatum',
        creator: 'Aangemaakt door',
        'full-contact-details': 'Volledige contactgegevens',
        company: 'Bedrijfsnaam',
        group: 'Groep',
        name: 'Naam',
        owner: 'Eigenaar',
        'owner-email': 'E-mailadres',
        'owner-phone': 'Telefoonnummer',
        address: 'Adres',
        postcode: 'Postcode',
        city: 'Stad',
        country: 'Land',
        phone: 'Telefoonnummer',
        email: 'E-mailadres',
        website: 'Website',
        type: 'Type',
        'start-date': 'Startdatum',
        'start-time': 'Starttijd',
        'end-date': 'Einddatum',
        'end-time': 'Eindtijd',
        soundcheck: 'Soundcheck-tijd',
        present: 'Aanwezig-tijd',
        title: 'Titel',
        description: 'Omschrijving',
        location: 'Locatie',
      },
    },
    activity: {
      create_title: 'Nieuwe activiteit',
      pending_invitation: 'Openstaande uitnodiging',
      form: {
        description: 'Wat',
        description_placeholder: 'Omschrijving van de activiteit',
        location: 'Waar',
        location_placeholder: 'Locatie van de activiteit',
        submit_create_of_type: 'Maak {type}',
        from: 'van',
        to: 't/m',
        duration: 'Wanneer',
        whole_day: 'Dag',
        part_of_day: 'Dag en tijd',
        multiple_days: 'Periode',
        submit_update_of_type: 'Wijzig {type}',
        recurring: 'Herhaling',
        submit_update_this: 'Wijzig alleen deze activiteit',
        submit_update_all: 'Wijzig alle toekomstige activiteiten',
        participants: 'Bezetting',
        present_time: 'Aanwezig om',
        soundcheck_time: 'Soundcheck om',
        requires_approval: 'Vraag goedkeuring van groepsleden',
        notify_participants: 'Breng groepsleden op de hoogte van wijziging',
        until: 'tot',
      },
      attributes: {
        duration_type: 'duurtype',
        start_date: 'startdatum',
        end_date: 'einddatum',
        start_time: 'starttijd',
        end_time: 'eindtijd',
        present_time: 'aanwezig',
        soundcheck_time: 'soundcheck',
        recurring: 'herhaling',
        participants: 'bezetting',
        requires_approval: 'goedkeuring',
      },
      messages: {
        created_of_type: 'De {type} is aangemaakt.',
        updated_of_type: 'De {type} is gewijzigd.',
        deleted_of_type: 'De {type} is verwijderd.',
      },
      by: 'Door',
      description: 'Omschrijving',
      location: 'Locatie',
      confirm_delete: 'Weet je zeker dat je deze activiteit wilt verwijderen?',
      back_to_calendar: 'Terug naar kalender',
      update_of_type: 'Wijzig {type}',
      group: 'Groep',
      select_group: 'Selecteer een groep',
      recurring: {
        weekly: 'Wekelijks',
        monthly: 'Maandelijks',
        yearly: 'Jaarlijks',
        not_recurring: 'Niet herhalen',
        biweekly: 'Tweewekelijks',
      },
      date_warning: {
        end_on_next: 'De activiteit eindigt op de volgende dag.',
        present_on_previous: 'De aanwezig-tijd is op de vorige dag.',
        soundcheck_on_previous: 'De soundcheck is op de vorige dag.',
        present_and_soundcheck_on_previous: 'De aanwezig-tijd en soundcheck zijn op de vorige dag.',
      },
      confirm_delete_all_future:
        'Weet je zeker dat je deze en alle toekomstige herhalingen van deze activiteit wilt verwijderen?',
      submit_delete_this: 'Verwijder alleen deze activiteit',
      submit_delete_all: 'Verwijder alle herhalingen',
      participants: 'Bezetting',
      choose_group_for_type: 'Kies groep voor {type}',
      present: 'Aanwezig',
      soundcheck: 'Soundcheck',
      approve: 'Goedkeuren',
      reject: 'Afwijzen',
      promote_to_type: 'Zet om naar {type}',
      maybe: 'Misschien',
      confirm_promote_from_old_type_to_type:
        'Weet je zeker dat je deze {oldType} wil wijzigen naar een {type}? Dit kan niet ongedaan gemaakt worden.',
      send_participation_state_reminder: 'Stuur herinnering',
      date: 'Datum',
      from: 'Van',
      to: 'Tot',
      until: 'Tot en met',
      time: 'Tijd',
      place: {
        view_on_google_maps: 'Bekijk op Google Maps',
      },
      choose_location_with_google_maps: 'Locatie wordt nu automatisch aangevuld door Google Maps.',
      limit_reached_for_type: 'Limit bereikt voor {type}',
      limit_reached_body:
        'Je hebt het limiet bereikt van aantal {type} dat je aan kunt maken. Voordat je nieuwe {type} aan kunt maken, dien je {type} te verwijderen of je account te upgraden.',
      validation: {
        limit_reached_without_type: 'Limit bereikt voor dit type activiteit',
        limit_reached_for_type: 'Deze groep heeft het limiet bereikt voor {type}.',
      },
      busy_state: 'Bezet ({type})',
      no_group: 'Geen groep (Persoonlijk)',
      confirm_reset_participation_state:
        'Weet je het zeker dat je de status van de bezetting wilt resetten? Het lid ontvangt een notificatie om opnieuw antwoord te geven.',
      reset: 'Reset',
      promote_to_many: 'Zet om naar...',
      created_by_at: 'Aangemaakt door {by} op {at}.',
      updated_at: 'Laatst gewijzigd op {at}.',
      contacts: 'Contacten',
      tasks: 'Taken',
      type: 'Soort activiteit',
      create: 'Maak activiteit',
      title: 'Titel',
      participation_without_user: '(onbekend groepslid)',
      documents: 'Documenten',
      create_document: 'Maak document',
    },
    calendar: {
      no_activities_in_month: 'Er zijn geen activiteiten in deze maand.',
      all_day: 'Hele dag',
      apply_filter: 'Filter toepassen',
      today: 'Vandaag',
      filter_toggle: 'Filteren',
      filter_type: 'Type',
      filter_group: 'Groep',
      submit_filter: 'Filter toepassen',
      week: 'Week',
      month: 'Maand',
      list: 'Lijst',
      filter: {
        types: 'Types',
        groups: 'Groepen',
        unfiltered: 'Alle',
        filtered: 'Gefilterd ({count})',
      },
      presets: {
        this_week: 'Deze week',
        last_week: 'Vorige week',
        this_month: 'Deze maand',
        last_month: 'Vorige maand',
        this_year: 'Dit jaar',
        last_year: 'Vorig jaar',
        today: 'Vandaag',
      },
      when: 'Wanneer',
      activity: 'Activiteit',
      location: 'Locatie',
      participants: 'Bezetting',
      day: 'Dag',
      no_activities_on_this_day: 'Er zijn geen activiteiten op deze dag.',
      number_of_activities: '{0} Geen activiteiten|{1} 1 activiteit|[2,*] {count} activiteiten',
      'no-activities': 'Er zijn geen activiteiten in deze periode.',
      'show-participants-overview': 'Toon bezettingsoverzicht',
      'show-user-activities': 'Toon leden-activiteiten',
      max_period: 'Lijst kan maximaal een periode van 1 jaar weergeven.',
      'show-groups-without-activities': 'Toon groepen zonder activiteit',
      'day-groups-full-width': 'Gebruik volledige breedte per groep',
    },
    activity_contacts: {
      title: 'Contacten',
      add_placeholder: 'Voeg een contact toe aan activiteit...',
      add_button: 'Toevoegen',
      view_contact: 'Bekijk',
      other_role: 'Overig',
      create_new: 'Nieuw contact aanmaken',
      notes: {
        title: 'Notities',
        create_placeholder: 'Voeg een nieuwe notitie toe...',
        confirm_deletion:
          'Weet je zeker dat je deze notitie wil verwijderen? Dit kan niet ongedaan gemaakt worden.',
        submit: 'Toevoegen',
      },
    },
    contacts: {
      address: 'Adres',
      agency: 'Agency',
      back_to_overview: 'Terug naar contacten',
      city: 'Stad',
      company: 'Bedrijfsnaam',
      confirm_delete:
        'Weet je zeker dat je deze contact wilt verwijderen? Deze zal tevens verwijderd worden bij gekoppelde activiteiten.',
      country: 'Land',
      create: 'Nieuw contact',
      edit: 'Contact wijzigen',
      email: 'E-mailadres',
      empty: 'Je hebt nog geen contacten toegevoegd.',
      emptyState: {
        action: 'Maak contact',
        description: 'Maak een begin door je eerste contact te maken.',
        title: 'Geen contacten',
      },
      filter: {
        filtered: 'Gefilterd ({count})',
        unfiltered: 'Alle',
      },
      group: 'Groep',
      messages: {
        created: 'Contact is aangemaakt.',
        deleted: 'Contact is verwijderd.',
        updated: 'Contact is gewijzigd.',
      },
      name: 'Naam',
      overview_title: 'Contacten',
      owner: 'Eigenaar van contact',
      personal: 'Persoonlijk',
      phone: 'Telefoonnummer',
      postcode: 'Postcode',
      role: 'Rol',
      roles: 'Rollen',
      select_a_role: 'Selecteer een rol...',
      submit_create: 'Contact opslaan',
      submit_update: 'Contact opslaan',
      tags: {
        create_new: 'Maak nieuwe tag',
        label: 'Tags',
        placeholder: 'Voeg een tag toe...',
      },
      view_all: 'Bekijk alle contacten',
      website: 'Website',
    },
    invitation: {
      invite_to_invitee: {
        members: 'Nodig lid uit voor {invitee}',
        groups: 'Nodig groep uit voor {invitee}',
        agents: 'Nodig agent uit voor {invitee}',
      },
      select_role: 'Selecteer een rol',
      as_stand_in: 'Als invaller',
      message: {
        deleted: 'De uitnodiging is verwijderd.',
        sent_amount: 'De uitnodiging is verzonden.|De uitnodigingen zijn verzonden.',
      },
      submit_send: 'Verstuur uitnodiging',
      add_more: 'Meer personen uitnodigen',
      attributes: {
        name: 'naam',
        email: 'e-mailadres',
        role: 'functie',
        as_stand_in: 'als invaller',
      },
      confirm_deletion:
        'Weet je zeker dat je deze uitnodiging wil verwijderen? De gegevens zullen verloren gaan.',
    },
    document_templates: {
      agency: 'Agency',
      confirm_delete:
        'Weet je zeker dat je deze sjabloon wil verwijderen? Dit kan niet ongedaan gemaakt worden.',
      content: 'Inhoud',
      create: 'Nieuw sjabloon',
      description: 'Omschrijving',
      empty: 'Je hebt nog geen sjablonen.',
      emptyState: {
        action: 'Maak sjabloon',
        description: 'Maak een begin door je eerste sjabloon te maken.',
        title: 'Geen sjablonen',
      },
      group: 'Groep',
      is_signable: 'Moet ondertekend worden door ontvanger',
      messages: {
        created: 'Het sjabloon is aangemaakt en kan gebruikt worden voor nieuwe documenten.',
        deleted: 'Het sjabloon is verwijderd.',
        no_owners: "Er zijn geen groepen of agency's waar je een sjabloon voor kan maken.",
        updated: 'Het sjabloon is gewijzigd.',
      },
      name: 'Naam',
      owner: 'Van',
      pick_owner: 'Selecteer een groep of agency...',
      submit_create: 'Maak sjabloon',
      submit_update: 'Sjabloon opslaan',
      title: 'Sjablonen',
      update: 'Wijzig sjabloon',
      validity_days: 'Dagen geldig',
    },
  },
}
